export type AddressLike = {
  address1?: string | null;
  address2?: string | null;
  city?: string | null;
  state?: string | null;
  zipCode?: string | null;
  county?: string | null;
  country?: string | null;
};

const isPresent = (value: unknown): value is string => {
  return typeof value === "string" && value.trim().length > 0;
};

export const composeAddressLine = (values: AddressLike): string => {
  const segments = [
    values.address1,
    values.address2,
    [values.city, values.state].filter(isPresent).join(", "),
    values.zipCode,
  ].filter(isPresent);

  return segments.join(", ");
};

export const defaultCountry = "United States";



export const emptyAddressFields = () => ({
  address1: "",
  address2: "",
  city: "",
  state: "",
  zipCode: "",
  county: "",
  country: defaultCountry,
});

export const normalizeAddressFields = (
  values: AddressLike
): ReturnType<typeof emptyAddressFields> => ({
  address1: values.address1 ?? "",
  address2: values.address2 ?? "",
  city: values.city ?? "",
  state: values.state ?? "",
  zipCode: values.zipCode ?? "",
  county: values.county ?? "",
  country: values.country ?? defaultCountry,
});
